"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mdi = exports.md = void 0;
const markdown_1 = require("very-small-parser/lib/markdown");
const mdast_flat_1 = require("mdast-flat");
const md = (markdown) => {
    const mdast = markdown_1.block.parsef(markdown);
    const flat = (0, mdast_flat_1.mdastToFlat)(mdast);
    return flat;
};
exports.md = md;
const mdi = (markdown) => {
    const mdast = {
        type: 'root',
        children: markdown_1.inline.parse(markdown),
    };
    const flat = (0, mdast_flat_1.mdastToFlat)(mdast);
    return flat;
};
exports.mdi = mdi;
